import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { pretestApi } from './pretestApi';
export default function CoursePretestButton({ courseId }) {
  const [availableFor, setAvailableFor] = useState(null);
  useEffect(() => { let active = true; setAvailableFor(null);
    if (courseId) pretestApi.list({ courseId, pageSize: 1 }).then(page => { if (active && page.items.length) setAvailableFor(courseId); }).catch(() => { /* Optional discovery must not block enrollment. */ });
    return () => { active = false; };
  }, [courseId]);
  if (!courseId || availableFor !== courseId) return null;
  return <Button as={Link} variant="outline-primary" to={`/pre-tests?courseId=${encodeURIComponent(courseId)}`}>แบบทดสอบ Pre-Test</Button>;
}
